import { render, staticRenderFns } from "./VaultView.vue?vue&type=template&id=178b61ba&"
import script from "./VaultView.vue?vue&type=script&lang=ts&"
export * from "./VaultView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports